import React, { useEffect } from 'react';
import LoginForm from './login-form/LoginForm';
import { ILoginProps } from './~types/LoginProps';
import { connect } from 'react-redux';
import { loginUser } from '../~store/actions/actions';
import './Login.css';
import { IApplicationState } from 'src/~store/models/ApplicationState';
import { showInfoToastr } from 'src/app/shared/helpers/toastr-helper/ToastrHelper';
import { useParams } from 'react-router-dom';
import { redirectToApp } from 'src/~store/history';

type ReduxType = ReturnType<typeof mapStateToProps> & ILoginProps;

const Login = (props: ReduxType) => {
    const { message } = useParams();

    useEffect(() => {
        if(message && message !== "")
            showInfoToastr(message);
    }, [message]);
    
    return (
        <section className="login-container">
            <LoginForm
                onLoginUser={(login, password) =>
                    props.loginUser(login, password, redirectToApp)
                }
            />
            <span className="login-build-version">
                build version: {process.env.REACT_APP_BUILD_VERSION}
            </span>
        </section>
    );
}

const mapStateToProps = (state: IApplicationState) => {
    return {}
}

const mapDispatchToProps = (dispatch: any): ILoginProps => {
    return {
        loginUser: (login: string, password: string, redirectToApp: () => void) =>
            dispatch(loginUser(login, password, redirectToApp)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);